import { useParams } from "react-router-dom";
import MotorDetailTemplate from "./MotorDetailTemplate";

import pcx from "./data/pcx";
import vario from "./data/vario-160";
import beat from "./data/beat";
import genio from "./data/genio";
import scoopy from "./data/scoopy";
import vario125 from "./data/vario-125";
import stylo160 from "./data/stylo160";
import adv160 from "./data/adv160";
import revo from "./data/revo";
import suprax from "./data/suprax";
import supragtr from "./data/supragtr";
import em1e from "./data/em1e";
import icone from "./data/icone";
import cuve from "./data/cuve";
import cb150 from "./data/cb150";
import sonic150r from "./data/sonic150r";
import cb150r from "./data/cb150r";
import cb150x from "./data/cb150x";
import cbr150r from "./data/cbr150r";
import crf150l from "./data/crf150l";
import cbr250rr from "./data/cbr250rr";
import monkey from "./data/monkey";
import crf250rally from "./data/crf250rally";

const DATA = {
  "pcx-160": pcx,
  "vario-160": vario,
  "beat": beat,
  "genio": genio,
  "scoopy": scoopy,
  "vario-125": vario125,
  "stylo-160": stylo160,
  "adv-160": adv160,
  "revo": revo,
  "supra-x": suprax,
  "supra-gtr-150": supragtr,
  "em1-e": em1e,
  "icon-e": icone,
  "cuv-e": cuve,
  "cb150-verza": cb150,
  "sonic-150r": sonic150r,
  "cb150r-streetfire": cb150r,
  "cb150x": cb150x,
  "cbr150r": cbr150r,
  "crf150l": crf150l,
  "cbr250rr": cbr250rr,
  "monkey": monkey,
  "crf250-rally": crf250rally,
};

const MotorDetail = () => {
  const { slug } = useParams();
  const data = DATA[slug];

  if (!data) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <h1 className="text-xl font-bold text-muted-foreground">
          Detail motor tidak ditemukan
        </h1>
      </div>
    );
  }

  return <MotorDetailTemplate data={data} />;
};

export default MotorDetail;
